import React from "react";
import PropTypes from 'prop-types';
import { ProgressSurveyAnswer, ProgressSurveyQuestion } from '../utils/types';
import ProgressSurveyTable from "./ProgressSurveyTable";
import { isMobileView } from 'utils/surveys';
import { useWindowSize } from 'react-use';

const ProgressSurveyTableView = props => {
  // Monitor window width
  const { width } = useWindowSize();

  // Has fetched and all data is available
  if ( props.hasFetched && props.surveyAnswers !== null && props.surveyQuestions !== null ) {
    const isMobile = isMobileView(props.surveyQuestions, width);
    return (
      <ProgressSurveyTable
        surveyAnswers={props.surveyAnswers}
        surveyQuestions={props.surveyQuestions}
        rebindStudentCards={props.rebindStudentCards}
        renderStudent={props.renderStudent}
        isMobile={isMobile}
      />
    );
  }

  // Still loading
  return <div>Loading survey...</div>;
}

ProgressSurveyTableView.propTypes = {
  surveyAnswers: PropTypes.arrayOf(ProgressSurveyAnswer),
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  hasFetched: PropTypes.bool.isRequired,
  rebindStudentCards: PropTypes.func.isRequired,
  renderStudent: PropTypes.func.isRequired,
};

export default ProgressSurveyTableView;
